import type { TableColumn } from "../components/common/Table/Table";
import type {
  TeamReportingOption,
  TeamReportingSearchMeta,
  TeamReportingSearchMode,
  TeamReportingSortDirection,
} from "../types/teamReporting.types";

export const TEAM_REPORTING_DEFAULT_PAGE = 1;
export const TEAM_REPORTING_DEFAULT_PAGE_SIZE = 10;
export const TEAM_REPORTING_DEFAULT_SORT_COLUMN = "teamId";
export const TEAM_REPORTING_DEFAULT_SORT_DIRECTION: TeamReportingSortDirection =
  "ASC";
export const TEAM_REPORTING_API_SORT_DIRECTION: TeamReportingSortDirection =
  "ASC";
export const TEAM_REPORTING_ALL_AREA_CODE = "All";
export const TEAM_REPORTING_ALL_ROLES_VALUE = "All";
export const TEAM_REPORTING_SELECT_VALUE = "Select";
export const TEAM_REPORTING_DEFAULT_SEARCH_MODE: TeamReportingSearchMode =
  "default";
export const TEAM_REPORTING_ADVANCED_SEARCH_MODE: TeamReportingSearchMode =
  "advance";
export const TEAM_REPORTING_LEADS_DATALIST_ID = "teams-reporting-leads-list";
export const TEAM_REPORTING_REGION_LOAD_VALUE = "REGION";
export const TEAM_REPORTING_AREA_LOAD_VALUE = "AREA";
export const TEAM_REPORTING_AREA_DEFAULT_SORT = "DEPTID";
export const TEAM_REPORTING_AREA_NAME_SORT = "DEPTNAME";

/** Identifier for the Export Membership Count (CSV) report option. */
export const EXPORT_MEMBERSHIP_COUNT_CSV_ID = "export_membership_count_csv";
export const EXPORT_MEMBERSHIP_COUNT_CSV_VALUE = "export_membership_count_csv";

export const TEAM_REPORTING_DEFAULT_OPTION: TeamReportingOption = {
  id: 0,
  label: TEAM_REPORTING_SELECT_VALUE,
  value: TEAM_REPORTING_SELECT_VALUE,
};

export const TEAM_REPORTING_ALL_AREA_OPTION: TeamReportingOption = {
  id: TEAM_REPORTING_ALL_AREA_CODE,
  label: TEAM_REPORTING_ALL_AREA_CODE,
  value: TEAM_REPORTING_ALL_AREA_CODE,
};

export const TEAM_REPORTING_EMPTY_META: TeamReportingSearchMeta = {
  total: 0,
  totalPages: 0,
  pageNumber: TEAM_REPORTING_DEFAULT_PAGE,
  pageSize: TEAM_REPORTING_DEFAULT_PAGE_SIZE,
};

export const TEAM_REPORTING_COLUMNS: TableColumn[] = [
  { key: "teamId", label: "UBT ID", isSortable: true, sortColumn: "teamId" },
  { key: "ubtName", label: "UBT Name", isSortable: true, sortColumn: "teamName" },
  { key: "teamLevelRating", label: "Team Level Rating", isSortable: true, sortColumn: "likertScaleRating" },
  { key: "regionName", label: "Region Name", isSortable: true, sortColumn: "regionDescription" },
  { key: "area", label: "Area", isSortable: true, sortColumn: "areaDescription" },
  { key: "consultant", label: "Consultant", isSortable: true, sortColumn: "consultantNames" },
  { key: "sponsor", label: "Sponsor", isSortable: true, sortColumn: "sponsorNames" },
  { key: "laborSponsor", label: "Labor Sponsor", isSortable: true, sortColumn: "laborSponsorNames" },
  { key: "proxy", label: "Proxy", isSortable: true, sortColumn: "proxyNames" },
  { key: "thWpsChampion", label: "TH/WPS Champion", isSortable: true, sortColumn: "thWpsChampionNames" },
  { key: "staffingChampion", label: "Staffing Champion", isSortable: true, sortColumn: "staffingChampionNames" },
  { key: "coLead", label: "Co-Lead", isSortable: true, sortColumn: "coLeadNames" },
  { key: "laborCoLead", label: "Labor Co-Lead", isSortable: true, sortColumn: "laborCoLeadNames" },
  { key: "lastUpdatedDate", label: "Last Updated Date", isSortable: true, sortColumn: "teamDateLastUpdated" },
];

export const TEAM_REPORTING_REPORT_OPTIONS: TeamReportingOption[] = [
  {
    id: "export_team_summary_csv",
    label: "Export Teams Reporting (CSV)",
    value: "export_team_summary_csv",
    iconPath: "/assets/images/printer-outline.svg",
  },
  {
    id: "teams_reporting",
    label: "Teams Reporting",
    value: "teams_reporting",
    iconPath: "/assets/images/printer-outline.svg",
  },
  {
    id: "p2P_detail_reporting_csv",
    label: "P2P Detail Reporting (CSV)",
    value: "p2P_detail_reporting_csv",
    iconPath: "/assets/images/printer-outline.svg",
  },
  {
    id: "p2P_detail_reporting_pdf",
    label: "P2P Detail Reporting (PDF)",
    value: "p2P_detail_reporting_pdf",
    iconPath: "/assets/images/download-outline.svg",
  },
  {
    id: EXPORT_MEMBERSHIP_COUNT_CSV_ID,
    label: "Export membership count (CSV)",
    value: EXPORT_MEMBERSHIP_COUNT_CSV_VALUE,
    iconPath: "/assets/images/printer-outline.svg",
  },
];

export const TEAM_REPORTING_ERROR_MESSAGES = {
  fetchAreaOptions: "Failed to fetch area options",
  fetchLeadsDropdown: "Failed to fetch teams reporting leads dropdown",
  fetchRatingRoles: "Failed to fetch teams reporting rating roles",
  fetchRegionOptions: "Failed to fetch region options",
  fetchSearchResults: "Failed to fetch teams reporting search results",
} as const;
